module.exports = __webpack_public_path__ + "assets/img/25_315_big.f99c8224.jpg";